<template>
  <div class="settle-accounts-info">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-footer
        :footer-method="footerMethod"
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button
            @click="introductionFeeHandler"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >引入费用</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'expenseType'">{{
              row['expenseType'] != null && row['expenseType'] != '' ? '押金' : ''
            }}</span>
            <span v-else-if="item.field == 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</span>
            <span v-else-if="item.field == 'currencyCode'">{{
              currencyList?.find((item) => item.value == row['currencyCode'])?.label
            }}</span>
            <span v-else-if="item.field == 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</span>
            <span v-else-if="item.field == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span>
            <span v-else-if="item.field == 'businessCategory'">{{
              businessCategory?.find((item) => item.value == row['businessCategory'])?.label
            }}</span>

            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <IntroductionCostDialog ref="IntroductionCostDialog" @confirmHandler="confirmHandler" />
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  import IntroductionCostDialog from '../IntroductionCostDialog/index.vue';
  export default {
    components: {
      IntroductionCostDialog,
    },
    name: 'SettleAccountsInfo',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      // 所有明细行
      lineDetailsList: {
        type: Array,
        default: () => [],
      },
      //当前选中的行数据
      currentSettleAccountRowData: {
        type: Object,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        currencyList: [],
        tableRules,
        tableColumnList,
        deleteLineDetailIds: [], //删除明细行的ids
      };
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['deductionOriginalAmount'].includes(column.property)) {
              // console.log(column.property, 'column.property');
              return this.sumNum(data, column.property);
            }
            if (['deductionDomesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          // console.log(item[field], '+item[field]00000000000');
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      //是否可以编辑
      activeRowMethod({ columnIndex }) {
        if (['create'].includes(this.$route.query?.status)) {
          // if (row?.id) {
          if (this.$route.query?.id) {
            if (
              columnIndex == 25 ||
              columnIndex == 26 ||
              columnIndex == 27 ||
              columnIndex == 4 ||
              columnIndex == 5 ||
              columnIndex == 18
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            // if (
            //   columnIndex == 4 ||
            //   columnIndex == 5 ||
            //   columnIndex == 18 ||
            //   columnIndex == 25 ||
            //   columnIndex == 26 ||
            //   columnIndex == 27
            // ) {
            //   return true;
            // } else {
            //   return false;
            // }
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
          // this.checkStatus = true;
        } else {
          return false;
          // this.checkStatus = false;
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.$emit('saveDeleteLineDetailIds', this.deleteLineDetailIds);
        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
        const { contractNo, supplierName, supplierNo } = this.currentSettleAccountRowData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }

        // 先获取表单中的币种和汇率
        const $table = this.$refs.settleAccountsRef;
        const rowData = {
          currencyCode,
          currencyName,
          exchangeRate,
          contractNo,
          delivererName: supplierName,
          delivererNo: supplierNo,
          deductionOriginalAmount: 0,
          deductionDomesticAmount: 0,
        };
        $table.setRadioRow(rowData);
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      introductionFeeHandler() {
        this.$emit('_formatSettleAccountDto');
        const { currencyName, exchangeRate, contractNo } = this.baseFormData;
        // const { contractNo } = this.currentSettleAccountRowData;
        if (!currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        const idList = this.tableDataList.map((item) => item.id) || [];
        setTimeout(() => {
          this.$refs.IntroductionCostDialog.lineDetailsList = this.lineDetailsList;
          this.$refs.IntroductionCostDialog.query.contractNo = contractNo;
          (this.$refs.IntroductionCostDialog.query.businessCompanyNo = this.userInfo.companyCode),
            (this.$refs.IntroductionCostDialog.query.businessDepartmentCode =
              this.userInfo.departmentCode),
            (this.$refs.IntroductionCostDialog.idList = idList);
          this.$refs.IntroductionCostDialog.openModal();
        }, 50);
      },
      confirmHandler(val) {
        this.$emit('importData', val);
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = this.selectionList.map((item) => item._XID);
        console.log(xIDList, 'xIDList');
        if (xIDList && xIDList.length) {
          let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
          deleteIds = deleteIds.filter((item) => item);
          this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
          console.log(this.deleteLineDetailIds, 'this.deleteLineDetailIds');
          this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
          this.$emit('deleteTableHandler', xIDList);
        }
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        if (field === 'currencyCode') {
          row['currencyName'] = this.currencyList?.find(
            (item) => item.value == row['currencyCode']
          )?.label;
        } else if (field === 'originalAmount') {
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'periodDateFrom') {
          if (row['periodDateUntil'] !== null) {
            if (
              new Date(row['periodDateFrom']).getTime() > new Date(row['periodDateUntil']).getTime()
            ) {
              this.$message.error('开始时间不能大于结束时间');
              row['periodDateFrom'] = null;
            }
          }
        } else if (field === 'periodDateUntil') {
          if (row['periodDateFrom'] !== null) {
            if (
              new Date(row['periodDateFrom']).getTime() > new Date(row['periodDateUntil']).getTime()
            ) {
              this.$message.error('结束时间不能小于开始时间');
              row['periodDateUntil'] = null;
            }
          }
        } else if (field === 'originalPrice') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';

          console.log(row['originalTaxAmount'], 'lineDetails999999999');
        } else if (field === 'taxRate') {
          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'settlementQuantity') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'deductionOriginalAmount') {
          row['deductionOriginalAmount'] = row['deductionOriginalAmount'] || 0;
          row['deductionDomesticAmount'] = (
            row['deductionOriginalAmount'] * row['exchangeRate']
          ).toFixed(2);
        } else if (field === 'unit') {
          row['unitName'] = this.basic_unit?.find((item) => item.value == row['unit'])?.label;
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      async closeEditTableHandler() {
        console.log('关闭');
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
          // await $table.clearActived();
        } else {
          // 派发事件
          this.$emit('closeEditTableHandler', this.getTableData());
          await $table.clearActived();
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      expenseType() {
        return this.dictListMap?.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      businessCategory() {
        return this.dictListMap?.businessCategoryPayable;
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getCurrencyList();
    },
  };
</script>

<style lang="scss" scoped>
  .settle-accounts-info {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
